import ZoneDetails from '@/pages/zones/slug';
import Error404 from '@/components/error/404';

import Zones from '@/pages/zones';
import type { RouteObject } from 'react-router-dom';

export const zonesRoutes: RouteObject[] = [
  {
    path: 'zones',
    errorElement: <Error404 />,
    element: <Zones />,
  },
  {
    path: 'zone/:slug',
    errorElement: <Error404 />,
    element: <ZoneDetails />,
  },
  {
    path: 'zones/:slug',
    errorElement: <Error404 />,
    element: <ZoneDetails />,
  },
];
